/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InvestmentStyleDiagnosisAgentAllOfAnswerLabels model module.
 * @module model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisAgentAllOfAnswerLabels {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisAgentAllOfAnswerLabels</code>.
     * 各回答の日本語ラベル（単一選択&#x3D;文字列／複数選択&#x3D;文字列配列）
     * @alias module:model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels
     */
    constructor() { 
        
        InvestmentStyleDiagnosisAgentAllOfAnswerLabels.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisAgentAllOfAnswerLabels</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels} The populated <code>InvestmentStyleDiagnosisAgentAllOfAnswerLabels</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisAgentAllOfAnswerLabels();

            if (data.hasOwnProperty('purposes')) {
                obj['purposes'] = ApiClient.convertToType(data['purposes'], ['String']);
            }
            if (data.hasOwnProperty('primary_purpose')) {
                obj['primary_purpose'] = ApiClient.convertToType(data['primary_purpose'], 'String');
            }
            if (data.hasOwnProperty('target_monthly_income')) {
                obj['target_monthly_income'] = ApiClient.convertToType(data['target_monthly_income'], 'String');
            }
            if (data.hasOwnProperty('interest_1st')) {
                obj['interest_1st'] = ApiClient.convertToType(data['interest_1st'], 'String');
            }
            if (data.hasOwnProperty('interest_2nd')) {
                obj['interest_2nd'] = ApiClient.convertToType(data['interest_2nd'], 'String');
            }
            if (data.hasOwnProperty('interest_3rd')) {
                obj['interest_3rd'] = ApiClient.convertToType(data['interest_3rd'], 'String');
            }
            if (data.hasOwnProperty('success_conditions')) {
                obj['success_conditions'] = ApiClient.convertToType(data['success_conditions'], ['String']);
            }
            if (data.hasOwnProperty('monthly_out_of_pocket')) {
                obj['monthly_out_of_pocket'] = ApiClient.convertToType(data['monthly_out_of_pocket'], 'String');
            }
            if (data.hasOwnProperty('borrowing_stance')) {
                obj['borrowing_stance'] = ApiClient.convertToType(data['borrowing_stance'], 'String');
            }
            if (data.hasOwnProperty('holding_period')) {
                obj['holding_period'] = ApiClient.convertToType(data['holding_period'], 'String');
            }
            if (data.hasOwnProperty('management_style')) {
                obj['management_style'] = ApiClient.convertToType(data['management_style'], 'String');
            }
            if (data.hasOwnProperty('short_term_sale_intent')) {
                obj['short_term_sale_intent'] = ApiClient.convertToType(data['short_term_sale_intent'], 'String');
            }
            if (data.hasOwnProperty('first_purchase_timing')) {
                obj['first_purchase_timing'] = ApiClient.convertToType(data['first_purchase_timing'], 'String');
            }
            if (data.hasOwnProperty('planner_comparison_count')) {
                obj['planner_comparison_count'] = ApiClient.convertToType(data['planner_comparison_count'], 'String');
            }
            if (data.hasOwnProperty('meeting_check_items')) {
                obj['meeting_check_items'] = ApiClient.convertToType(data['meeting_check_items'], ['String']);
            }
            if (data.hasOwnProperty('explanation_styles')) {
                obj['explanation_styles'] = ApiClient.convertToType(data['explanation_styles'], ['String']);
            }
            if (data.hasOwnProperty('anxiety_loan')) {
                obj['anxiety_loan'] = ApiClient.convertToType(data['anxiety_loan'], 'String');
            }
            if (data.hasOwnProperty('anxiety_vacancy')) {
                obj['anxiety_vacancy'] = ApiClient.convertToType(data['anxiety_vacancy'], 'String');
            }
            if (data.hasOwnProperty('anxiety_exit')) {
                obj['anxiety_exit'] = ApiClient.convertToType(data['anxiety_exit'], 'String');
            }
            if (data.hasOwnProperty('anxiety_repair')) {
                obj['anxiety_repair'] = ApiClient.convertToType(data['anxiety_repair'], 'String');
            }
            if (data.hasOwnProperty('anxiety_sales_pressure')) {
                obj['anxiety_sales_pressure'] = ApiClient.convertToType(data['anxiety_sales_pressure'], 'String');
            }
            if (data.hasOwnProperty('avoid_sales_styles')) {
                obj['avoid_sales_styles'] = ApiClient.convertToType(data['avoid_sales_styles'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisAgentAllOfAnswerLabels</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisAgentAllOfAnswerLabels</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['purposes'])) {
            throw new Error("Expected the field `purposes` to be an array in the JSON data but got " + data['purposes']);
        }
        // ensure the json data is a string
        if (data['primary_purpose'] && !(typeof data['primary_purpose'] === 'string' || data['primary_purpose'] instanceof String)) {
            throw new Error("Expected the field `primary_purpose` to be a primitive type in the JSON string but got " + data['primary_purpose']);
        }
        // ensure the json data is a string
        if (data['target_monthly_income'] && !(typeof data['target_monthly_income'] === 'string' || data['target_monthly_income'] instanceof String)) {
            throw new Error("Expected the field `target_monthly_income` to be a primitive type in the JSON string but got " + data['target_monthly_income']);
        }
        // ensure the json data is a string
        if (data['interest_1st'] && !(typeof data['interest_1st'] === 'string' || data['interest_1st'] instanceof String)) {
            throw new Error("Expected the field `interest_1st` to be a primitive type in the JSON string but got " + data['interest_1st']);
        }
        // ensure the json data is a string
        if (data['interest_2nd'] && !(typeof data['interest_2nd'] === 'string' || data['interest_2nd'] instanceof String)) {
            throw new Error("Expected the field `interest_2nd` to be a primitive type in the JSON string but got " + data['interest_2nd']);
        }
        // ensure the json data is a string
        if (data['interest_3rd'] && !(typeof data['interest_3rd'] === 'string' || data['interest_3rd'] instanceof String)) {
            throw new Error("Expected the field `interest_3rd` to be a primitive type in the JSON string but got " + data['interest_3rd']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['success_conditions'])) {
            throw new Error("Expected the field `success_conditions` to be an array in the JSON data but got " + data['success_conditions']);
        }
        // ensure the json data is a string
        if (data['monthly_out_of_pocket'] && !(typeof data['monthly_out_of_pocket'] === 'string' || data['monthly_out_of_pocket'] instanceof String)) {
            throw new Error("Expected the field `monthly_out_of_pocket` to be a primitive type in the JSON string but got " + data['monthly_out_of_pocket']);
        }
        // ensure the json data is a string
        if (data['borrowing_stance'] && !(typeof data['borrowing_stance'] === 'string' || data['borrowing_stance'] instanceof String)) {
            throw new Error("Expected the field `borrowing_stance` to be a primitive type in the JSON string but got " + data['borrowing_stance']);
        }
        // ensure the json data is a string
        if (data['holding_period'] && !(typeof data['holding_period'] === 'string' || data['holding_period'] instanceof String)) {
            throw new Error("Expected the field `holding_period` to be a primitive type in the JSON string but got " + data['holding_period']);
        }
        // ensure the json data is a string
        if (data['management_style'] && !(typeof data['management_style'] === 'string' || data['management_style'] instanceof String)) {
            throw new Error("Expected the field `management_style` to be a primitive type in the JSON string but got " + data['management_style']);
        }
        // ensure the json data is a string
        if (data['short_term_sale_intent'] && !(typeof data['short_term_sale_intent'] === 'string' || data['short_term_sale_intent'] instanceof String)) {
            throw new Error("Expected the field `short_term_sale_intent` to be a primitive type in the JSON string but got " + data['short_term_sale_intent']);
        }
        // ensure the json data is a string
        if (data['first_purchase_timing'] && !(typeof data['first_purchase_timing'] === 'string' || data['first_purchase_timing'] instanceof String)) {
            throw new Error("Expected the field `first_purchase_timing` to be a primitive type in the JSON string but got " + data['first_purchase_timing']);
        }
        // ensure the json data is a string
        if (data['planner_comparison_count'] && !(typeof data['planner_comparison_count'] === 'string' || data['planner_comparison_count'] instanceof String)) {
            throw new Error("Expected the field `planner_comparison_count` to be a primitive type in the JSON string but got " + data['planner_comparison_count']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['meeting_check_items'])) {
            throw new Error("Expected the field `meeting_check_items` to be an array in the JSON data but got " + data['meeting_check_items']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['explanation_styles'])) {
            throw new Error("Expected the field `explanation_styles` to be an array in the JSON data but got " + data['explanation_styles']);
        }
        // ensure the json data is a string
        if (data['anxiety_loan'] && !(typeof data['anxiety_loan'] === 'string' || data['anxiety_loan'] instanceof String)) {
            throw new Error("Expected the field `anxiety_loan` to be a primitive type in the JSON string but got " + data['anxiety_loan']);
        }
        // ensure the json data is a string
        if (data['anxiety_vacancy'] && !(typeof data['anxiety_vacancy'] === 'string' || data['anxiety_vacancy'] instanceof String)) {
            throw new Error("Expected the field `anxiety_vacancy` to be a primitive type in the JSON string but got " + data['anxiety_vacancy']);
        }
        // ensure the json data is a string
        if (data['anxiety_exit'] && !(typeof data['anxiety_exit'] === 'string' || data['anxiety_exit'] instanceof String)) {
            throw new Error("Expected the field `anxiety_exit` to be a primitive type in the JSON string but got " + data['anxiety_exit']);
        }
        // ensure the json data is a string
        if (data['anxiety_repair'] && !(typeof data['anxiety_repair'] === 'string' || data['anxiety_repair'] instanceof String)) {
            throw new Error("Expected the field `anxiety_repair` to be a primitive type in the JSON string but got " + data['anxiety_repair']);
        }
        // ensure the json data is a string
        if (data['anxiety_sales_pressure'] && !(typeof data['anxiety_sales_pressure'] === 'string' || data['anxiety_sales_pressure'] instanceof String)) {
            throw new Error("Expected the field `anxiety_sales_pressure` to be a primitive type in the JSON string but got " + data['anxiety_sales_pressure']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['avoid_sales_styles'])) {
            throw new Error("Expected the field `avoid_sales_styles` to be an array in the JSON data but got " + data['avoid_sales_styles']);
        }

        return true;
    }


}



/**
 * @member {Array.<String>} purposes
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['purposes'] = undefined;

/**
 * @member {String} primary_purpose
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['primary_purpose'] = undefined;

/**
 * @member {String} target_monthly_income
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['target_monthly_income'] = undefined;

/**
 * @member {String} interest_1st
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['interest_1st'] = undefined;

/**
 * @member {String} interest_2nd
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['interest_2nd'] = undefined;

/**
 * @member {String} interest_3rd
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['interest_3rd'] = undefined;

/**
 * @member {Array.<String>} success_conditions
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['success_conditions'] = undefined;

/**
 * @member {String} monthly_out_of_pocket
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['monthly_out_of_pocket'] = undefined;

/**
 * @member {String} borrowing_stance
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['borrowing_stance'] = undefined;

/**
 * @member {String} holding_period
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['holding_period'] = undefined;

/**
 * @member {String} management_style
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['management_style'] = undefined;

/**
 * @member {String} short_term_sale_intent
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['short_term_sale_intent'] = undefined;

/**
 * @member {String} first_purchase_timing
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['first_purchase_timing'] = undefined;

/**
 * @member {String} planner_comparison_count
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['planner_comparison_count'] = undefined;

/**
 * @member {Array.<String>} meeting_check_items
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['meeting_check_items'] = undefined;

/**
 * @member {Array.<String>} explanation_styles
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['explanation_styles'] = undefined;

/**
 * @member {String} anxiety_loan
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['anxiety_loan'] = undefined;

/**
 * @member {String} anxiety_vacancy
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['anxiety_vacancy'] = undefined;

/**
 * @member {String} anxiety_exit
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['anxiety_exit'] = undefined;

/**
 * @member {String} anxiety_repair
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['anxiety_repair'] = undefined;

/**
 * @member {String} anxiety_sales_pressure
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['anxiety_sales_pressure'] = undefined;

/**
 * @member {Array.<String>} avoid_sales_styles
 */
InvestmentStyleDiagnosisAgentAllOfAnswerLabels.prototype['avoid_sales_styles'] = undefined;






export default InvestmentStyleDiagnosisAgentAllOfAnswerLabels;

